module.exports = __webpack_public_path__ + "img/anaglyph2.3bab7742.gif";